var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstructions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.5C7.343 6.5 6 7.843 6 9.5C6 11.157 7.343 12.5 9 12.5C10.657 12.5 12 11.157 12 9.5C12 7.843 10.657 6.5 9 6.5ZM10.596 9.601L9.4895 10.663C9.2635 10.886 8.9635 10.9985 8.663 10.9985C8.3625 10.9985 8.0615 10.886 7.8315 10.6615L7.2655 10.107C7.068 9.9135 7.0655 9.597 7.2585 9.4C7.4515 9.202 7.768 9.1995 7.9655 9.393L8.531 9.947C8.603 10.018 8.7205 10.0165 8.792 9.946L9.9035 8.879C10.102 8.688 10.419 8.6935 10.6105 8.8935C10.8015 9.0925 10.795 9.4095 10.596 9.601ZM5 9.5C5 8.305 5.524 7.233 6.3545 6.5H2.5C2.2235 6.5 2 6.2765 2 6C2 5.7235 2.2235 5.5 2.5 5.5H6.5C6.7765 5.5 7 5.7235 7 6C7 6.012 6.9995 6.024 6.9985 6.036C7.587 5.695 8.2705 5.5 9 5.5V3C9 1.6215 7.8785 0.5 6.5 0.5H2.5C1.1215 0.5 0 1.6215 0 3V10C0 11.3785 1.1215 12.5 2.5 12.5H6.3545C5.524 11.767 5 10.695 5 9.5ZM2.5 3H6.5C6.7765 3 7 3.2235 7 3.5C7 3.7765 6.7765 4 6.5 4H2.5C2.2235 4 2 3.7765 2 3.5C2 3.2235 2.2235 3 2.5 3ZM3.5 9H2.5C2.2235 9 2 8.7765 2 8.5C2 8.2235 2.2235 8 2.5 8H3.5C3.7765 8 4 8.2235 4 8.5C4 8.7765 3.7765 9 3.5 9Z",
    fill: "#26445A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructions);
export default __webpack_public_path__ + "static/media/instructions.00f584a014cbf71862e89b7691da6626.svg";
export { ForwardRef as ReactComponent };